import React from 'react'
import styled from 'styled-components'
import IconButton from '../icon-button/IconButton'
import Logo from '../logo/Logo'

interface HeaderLogoProps {
  href: string
  color?: string
  className?: string
}

const HeaderLogoBase: React.FC<HeaderLogoProps> = ({href, className}) => {
  return (
    <IconButton
      icon={<Logo />}
      label="Miro Logo"
      href={href}
      className={className}
      title="Go to the main page"
    />
  )
}

const HeaderLogo = styled(HeaderLogoBase)`
  svg {
    display: block;
    width: 100%;
    height: auto;
  }

  svg path {
    fill: ${props => props.color};
  }

  ${({theme}) =>
    theme.normalizeStyles({
      position: 'absolute',
      display: 'block',
      top: [12, 25, '25px', '25px'],
      width: [89, 89, '89px', '89px'],
      height: [32, 32, '32px', '32px'],
    })}
`

export default HeaderLogo
